import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const PAREN_CATEGORY_CONTAINER_CLASS = "parent-category-container";
export const CHANGE_COLOR_ON_HOVER = "change-color-on-hover";

const { carbon, blue } = colorsPalettes;

const Text = styled.span`
    ${setFontVariant("subtitle2", carbon[300])};
`;
export const BoldText = styled(Text)`
    color: ${carbon[400]};
`;
export const Link = styled.a`
    color: ${carbon[400]};
    transition: 500ms;
`;

export const ParentCategoryCellContainer = styled.div`
    height: 100%;
    align-items: center;
    display: flex;
`;

export const ChildCategoryCellContainer = styled.div`
    overflow: hidden;
    height: 100%;
    align-items: center;
    width: 100%;
    display: flex;
    gap: 4px;
`;

export const Ellipsis = styled(Text)`
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    ${setFontVariant("input2", carbon[400])};
`;

const VERTICAL_SPACE = 10;
const HORIZONTAL_SPACE = 12;

export const Container = styled.div<{ isClickable: boolean }>`
    /** override the parent padding in order to active the hover state */
    /**
     * The calc() sizes below describe the border box: they are the cell plus the padding this
     * element re-adds. Without border-box they are read as the *content* box, so the element
     * ends up 2 * VERTICAL_SPACE too tall, and the height: 100% flex children inside it then
     * centre their text against that oversized box — pushing it VERTICAL_SPACE below the
     * middle of the cell.
     */
    box-sizing: border-box;
    margin: -${VERTICAL_SPACE}px -${HORIZONTAL_SPACE}px;
    padding: ${VERTICAL_SPACE}px ${HORIZONTAL_SPACE}px;
    height: calc(100% + ${2 * VERTICAL_SPACE}px);
    width: calc(100% + ${2 * HORIZONTAL_SPACE}px);
    &:hover {
        .${CHANGE_COLOR_ON_HOVER} {
            color: ${blue[400]};
        }
        .${PAREN_CATEGORY_CONTAINER_CLASS} {
            display: flex;
            opacity: 1;
        }
    }
    ${({ isClickable = false }) => isClickable && `cursor: pointer`}
`;

export const ParentCategoryContainer = styled.div`
    gap: 4px;
    display: none;
    opacity: 0;
    height: 100%;
    align-items: center;
`;

export const ParentCategory = styled(Text)`
    ${setFontVariant("dataTable1", carbon[300])};
    font-weight: 400;
    line-height: unset;
`;
